import { WSAlert } from "@wingspanhq/fe-component-library";
import { IWorkLog, WorkLogStatus } from "@wingspanhq/payments/dist/interfaces";
import React, { useMemo } from "react";
import { usePayableQuery } from "../../../Invoices/screens/payables/PayableDetails";

type Props = {
  workLog: IWorkLog | undefined;
};

export const AlertWorkLogInvoiceStatusPayer: React.FC<Props> = ({
  workLog
}) => {
  const invoiceId = workLog?.invoiceId;
  const isApproved = workLog?.status === WorkLogStatus.Approved;

  const queryPayable = usePayableQuery(invoiceId!, {
    enabled: !!invoiceId && isApproved,
    retry: false
  });

  // Show alert if work log is approved with invoiceId but payable not accessible
  const showAlert = useMemo(() => {
    const isDataEmptyObject =
      !!queryPayable.data && Object.keys(queryPayable.data).length === 0;

    return (
      isApproved &&
      !!invoiceId &&
      ((queryPayable.isError &&
        (queryPayable.error?.status === 404 ||
          queryPayable.error?.status === 403)) ||
        isDataEmptyObject)
    );
  }, [isApproved, invoiceId, queryPayable]);

  if (!showAlert) {
    return null;
  }

  return (
    <WSAlert theme="info" icon="time" title="Awaiting invoice from contractor">
      The work log has been submitted, but the contractor has not yet sent their
      invoice. Once submitted, it will appear in your payables.
    </WSAlert>
  );
};
